<template>
  <div class="optionBank">
    <section class="page-content">
      <header class="title">你希望支持绑定哪些银行卡</header>
      <p class="sub-title">可多选</p>
      <div class="choose-form">
        <div class="form-item" @click="choose(i)" v-for="(bank, i) in choosedBanks" :key="i">
          <span>{{bank.name}}</span>
          <i class="iconfont etc-icon-check" color-primary v-if="bank.checked"></i>
          <i class="iconfont etc-icon-yuan" v-else></i>
        </div>
        <div class="form-item no-border-bottom" @click="chooseElse = !chooseElse">
          <span>其他银行</span>
          <i class="iconfont etc-icon-check" color-primary v-if="chooseElse"></i>
          <i class="iconfont etc-icon-yuan" v-else></i>
        </div>
        <input type="text" placeholder="请填写" v-model="remark" class="else">
      </div>
    </section>
    <section class="page-bottom">
      <button cool-btn @click="submit">提交</button>
      <div class="fixed-bottom"></div>
    </section>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// apis
import NewApplyApi from '@/api/newApply.api'

export default {
  name: 'optionBank',
  mixins: [FunMixin],
  components: {},
  data() {
    return {
      choosedBanks: [
        {name: '建设银行', checked: false},
        {name: '邮储银行', checked: false},
        {name: '招商银行', checked: false},
        {name: '交通银行', checked: false}
      ],
      chooseElse: false,
      remark: ''
    }
  },
  computed: {},
  methods: {
    choose(i) {
      this.choosedBanks[i].checked = !this.choosedBanks[i].checked
    },
    async submit() {
      const bankResult = this.choosedBanks.filter(item => item.checked).map(item => item.name)
      this.m_showLoading()
      try {
        await NewApplyApi.optionBank({
          questionnaire_type: 1,
          choice: bankResult.toString(),
          remark: this.chooseElse ? this.remark : ''
        })
        this.m_showToast('提交成功')
        await this.m_awaitTime()
        this.m_replacePagesWithQ('result', {type: 'optionBank'})
      } catch (e) {
      } finally {
        this.m_loadingClose()
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";

.optionBank {
  background-color: #f5f5f5;
  .page-content {
    padding-bottom: 130px;
    .title{
      padding-top: 30px;
      font-size: 32px;
      font-weight: bold;
      text-align: center;
    }
    .sub-title{
      font-size: 26px;
      color: #666666;
      margin-top: 10px;
      text-align: center;
    }
    .choose-form{
      background-color: #fff;
      padding: 0 40px 50px;
      margin-top: 30px;
      .form-item{
        height: 100px;
        border-bottom: 1px solid #dddddd;
        @extend %flex-space-between;
        font-size: 30px;
        i{
          font-size: 42px;
        }
        .etc-icon-check{
        }
        .etc-icon-yuan{
          color: #999999;
        }
      }
      .else{
        margin-top: 10px;
        height: 82px;
        border-radius: 6px;
        border: 1px solid #cccccc;
        width: 100%;
        font-size: 30px;
        padding: 0 20px;
      }
    }
  }
  .page-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px 55px 30px;
  }
}
</style>
